import { createTypedUseAuth } from '@codezo/auth';
import { AuthRoleEnum, CurrencyEnum, MeasurementSystemEnum } from '@codezo/graphql';

export type OrganizationUserType = {
	id: string;
	email: string;
	role: AuthRoleEnum;
	organizationId: string;
	organization: {
		id: string;
		name: string;
		onboarded: boolean;
		organizationSetting?: {
			timezone: string;
			currency: CurrencyEnum;
			measurementSystem: MeasurementSystemEnum;
		} | null;
	};
	organizationUser: {
		id: string;
		firstName: string;
		lastName: string;
	};
};

export const useAuth = createTypedUseAuth<OrganizationUserType>();
